import { createSlice } from '@reduxjs/toolkit'

import { servicebooking } from '../../services/userServices'
import { RootState } from '../../store/store'

// State type for the Redux slice
interface UserState {
  loading: boolean
  error: string | undefined
}

// Initial state for the Redux slice
const initialState: UserState = {
  loading: false,
  error: undefined
}

// Create a Redux slice
export const bookingSlice = createSlice({
  name: 'booking',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(servicebooking.pending, (state) => {
      state.loading = true
    })
    builder.addCase(
      servicebooking.fulfilled,
      (state) => {
        state.loading = false
        state.error = undefined
      }
    )
    builder.addCase(servicebooking.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  }
})

// Selectors
export const bookingSelector = (state: RootState): UserState => state.bookingReducer
export default bookingSlice.reducer
